import React,{useState} from 'react';
import {motion} from 'framer-motion';
import {format} from 'date-fns';
import {es} from 'date-fns/locale';
import IncidentDetailModal from './IncidentDetailModal';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAlertCircle,FiClock,FiUser,FiMapPin}=FiIcons;

const IncidentsList=({incidents})=> {
  const [selectedIncident,setSelectedIncident]=useState(null);

  const getPriorityColor=(priority)=> {
    const colors={
      baja: 'bg-green-100 text-green-800',
      media: 'bg-yellow-100 text-yellow-800',
      alta: 'bg-orange-100 text-orange-800',
      critica: 'bg-red-100 text-red-800'
    };
    return colors[priority] || 'bg-gray-100 text-gray-800';
  };

  const getStatusColor=(status)=> {
    const colors={
      pendiente: 'bg-yellow-100 text-yellow-800',
      en_proceso: 'bg-blue-100 text-blue-800',
      resuelto: 'bg-green-100 text-green-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const getStatusLabel=(status)=> {
    const labels={
      pendiente: 'Pendiente',
      en_proceso: 'En Proceso',
      resuelto: 'Resuelto'
    };
    return labels[status] || status;
  };

  const getPriorityLabel=(priority)=> {
    const labels={
      baja: 'Baja',
      media: 'Media',
      alta: 'Alta',
      critica: 'Crítica'
    };
    return labels[priority] || priority;
  };

  if (incidents.length===0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <SafeIcon icon={FiAlertCircle} className="text-4xl text-gray-300 mx-auto mb-4" />
        <p className="text-gray-500">No se encontraron incidencias</p>
      </div>
    );
  }

  return (
    <>
      <div className="space-y-3">
        {incidents.map((incident,index)=> (
          <motion.div 
            key={incident.id} 
            initial={{opacity: 0,y: 10}} 
            animate={{opacity: 1,y: 0}} 
            transition={{delay: index * 0.05}}
            onClick={()=> setSelectedIncident(incident)}
            className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                {/* Nombre del usuario */}
                <h3 className="font-semibold text-gray-800 mb-1">
                  {incident.owner || 'Usuario sin nombre'}
                </h3>
                
                {/* Número de empleado */}
                <p className="text-sm text-gray-600 mb-1">
                  Empleado: {incident.employeeCode || 'N/A'}
                </p>
                
                {/* Vestuario y taquilla */}
                <p className="text-sm text-gray-600 mb-1">
                  {incident.wardrobeName && incident.locker 
                    ? `${incident.wardrobeName} - ${incident.locker}` 
                    : 'Ubicación no especificada'}
                </p>
                
                {/* Motivo de la incidencia (descripción) */}
                <p className="text-sm text-gray-600 line-clamp-2">
                  {incident.description}
                </p>
              </div>
              
              <div className="flex flex-col items-end space-y-2 ml-4">
                {/* Etiquetas de prioridad y estado */}
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(incident.priority)}`}>
                  {getPriorityLabel(incident.priority)}
                </span>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(incident.status)}`}>
                  {getStatusLabel(incident.status)}
                </span>
              </div>
            </div>
            
            {/* Fecha */}
            <div className="flex items-center justify-between text-sm text-gray-500">
              <div className="flex items-center space-x-4">
                {incident.responsible && (
                  <div className="flex items-center space-x-1">
                    <SafeIcon icon={FiUser} className="text-xs" />
                    <span>{incident.responsible}</span>
                  </div>
                )}
              </div>
              <div className="flex items-center space-x-1">
                <SafeIcon icon={FiClock} className="text-xs" />
                <span>
                  {format(new Date(incident.createdAt),'dd/MM/yyyy HH:mm',{locale: es})}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      
      {selectedIncident && (
        <IncidentDetailModal 
          incident={selectedIncident} 
          onClose={()=> setSelectedIncident(null)} 
        />
      )}
    </>
  );
};

export default IncidentsList;